<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <v-toolbar dark color="primary">
                    <v-layout row justify-end align-center>
                        <v-flex xs12 md2>
                            <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Tìm kiếm"
                                single-line
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-select
                                label="Tòa nhà"
                                :disabled="loading.submit"
                                v-model="chosen_building"
                                :items="list_building"
                                prepend-icon="domain"
                                required
                                single-line
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-select
                                label="Tình trạng phòng"
                                :disabled="loading.submit"
                                v-model.number="chosen_room_status"
                                :items="list_room_status"
                                prepend-icon="domain"
                                required
                                single-line
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-btn :loading="loader" @click="getData" color="green" dark>
                                Tìm kiếm
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-btn
                                :loading="loader"
                                :disabled="loader"
                                @click="exportCSV"
                                color="green"
                                class="white--text"
                            >XUẤT EXCEL</v-btn>

                            <export-csv-button
                                    :trigger="export_csv.trigger"
                                    :title="export_csv.title"
                                    :rows="export_csv.rows"
                            ></export-csv-button>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-btn
                                :loading="loader"
                                :disabled="loader"
                                @click="print_portal = true"
                                color="primary"
                            >
                                <v-icon small left>print</v-icon>
                                In danh sách
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-toolbar>
                <div class="mt-3">
                    <v-card>
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :rows-per-page-items="rowPerPage"
                            :loading="loader"
                            disable-initial-sort
                            :search="search"
                        >
                            <template #items="props">
                                <tr>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-center']">{{ props.index + 1 }}</td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-center']">{{ props.item.room_id }}</td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-center']">{{ props.item.room_code || '-' }}</td>
                                    <td class="text-no-wrap">
                                        <v-edit-dialog
                                            large
                                            lazy
                                            @save="updateRoomPicture(props.item)"
                                            @open="props.item.picture_description_new = props.item.picture_description"
                                        >
                                            {{ props.item.picture_description || props.item.has_picture || ""}}
                                            <template v-slot:input>
                                                <v-text-field
                                                    v-model="props.item.picture_description_new"
                                                    label="Mã hình"
                                                    single-line
                                                ></v-text-field>
                                            </template>
                                        </v-edit-dialog>
                                    </td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-no-wrap text-center']">
                                        <span v-if="!props.item.room_status">
                                            {{ room_status[props.item.room_status] || room_status[0] }}{{ props.item.is_included_air_conditioner || props.item.is_current_ac ? ", máy lạnh" : ""}}
                                        </span>
                                        <span v-else>
                                            {{ props.item.date_schedule_out | formatTimeServer}} {{ props.item.is_included_air_conditioner || props.item.is_current_ac ? " (ML)" : ""}}
                                        </span>
                                    </td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-no-wrap text-right']">{{ props.item.room_price | formatNumber}}</td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-no-wrap text-right']">{{ (props.item.room_price_standard ? props.item.room_price_standard : '-') | formatNumber }}</td>
                                    <!-- <td class="text-no-wrap">
                                        <v-chip
                                            v-if="props.item.is_passed_date_schedule_in && props.item.date_in"
                                            :color="props.item.note ? 'yellow' : 'red'"
                                            :text-color="props.item.note ? 'black' : 'white'"
                                        >
                                            {{ props.item.note ? 'Quá ngày hẹn vào ở, đã ghi chú' : 'Quá ngày hẹn vào ở' }}
                                        </v-chip>
                                        <v-chip
                                            v-if="props.item.is_passed_date_schedule_in && !props.item.date_in"
                                            color="orange"
                                            text-color="white"
                                        >
                                            Đến ngày nhận phòng
                                        </v-chip>
                                    </td> -->
                                    <!-- <td class="text-no-wrap">{{ props.item.room_state_id }}</td> -->
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-no-wrap']">{{ props.item.phone }}</td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-no-wrap']">{{ props.item.date_schedule_out | formatTimeServer}}</td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-no-wrap']">{{ props.item.date_out | formatTimeServer}}</td>
                                    <td class="text-no-wrap">{{ props.item.return_deposit_status_text }}</td>
                                    <td :class="['text-no-wrap', props.item.is_check_in_alert ? 'ts-warning' : '', !props.item.room_status ? 'red--text' : '']">{{ props.item.date_schedule_in | formatTimeServer}}</td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-no-wrap']">{{ props.item.date_in | formatTimeServer}}</td>
                                    <td class="">{{ props.item.is_deposit || 'Chưa cọc' }}</td>
                                    <td :class="[!props.item.room_status ? 'red--text' : '', 'text-no-wrap']">
                                        <v-edit-dialog
                                            large
                                            lazy
                                            @save="saveNote(props.item)"
                                            @open="props.item.new_note = props.item.note"
                                        >
                                            {{ props.item.note }}
                                            <template v-slot:input>
                                                <v-text-field
                                                    v-model="props.item.new_note"
                                                    label="Ghi chú"
                                                    single-line
                                                ></v-text-field>
                                            </template>
                                        </v-edit-dialog>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </div>
            </v-flex>
        </v-layout>
    </v-container>

	<print-portal layout="portrait" :open="print_portal" @close="print_portal = false">
		<print-tinh-trang-phong :room_status="chosen_room_status" :items="items"></print-tinh-trang-phong>
	</print-portal>
</div>
</template>

<script>
import api from '../../api'
import { buildParamQuery, formatTimeServer, dayDiff } from 'Helpers'
import moment from 'moment'
import { room_status } from 'Constants/db-config' 
import { list_building } from 'Constants/db-config'
import PrintPortal from 'Components/Print/PrintPortal'
import PrintTinhTrangPhong from 'Components/Print/PrintDanhSachTinhTrangPhong'
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'


export default {
    name: "theo-doi-tinh-trang-phong",
    components: {
        PrintPortal,
        PrintTinhTrangPhong,
        ExportCsvButton
    },
    data() {
        return {
            loader: false,
            search:'',
            headers: [
                { text: "STT", align: "center", value: "room_id" },
                { text: "Phòng", align: "center", value: "room_id" },
                { text: "Mã phòng", align: "center", value: "room_code" },
                { text: "Hình", align: "center", value: "has_picture", width: "150px" },
                { text: "Tình Trạng", align: "center", value: "room_status" },
                { text: "Giá Phòng Cho Thuê", align: "right", value: "room_price" },
                { text: "Giá Chuẩn", align: "right", value: "room_price_standard" },
                // { text: "Control", align: "center", value: "control_status" },
                // { text: "Giá Mới", align: "left", value: "new_price" },
                // { text: "Mã quản lý", align: "left", value: "room_state_id" },
                { text: "SĐT", align: "left", value: "phone" },
                { text: "Ngày Báo Trả", align: "left", value: "date_schedule_out" },
                { text: "Ngày Thực Trả", align: "left", value: "date_out" },
                { text: "Đã Trả Cọc", align: "left", value: "return_deposit_status_text" },
                { text: "Ngày Báo Nhận", align: "left", value: "date_schedule_in" },
                { text: "Ngày Thực Nhận", align: "left", value: "date_in" },
                { text: "Đã Thu Cọc", align: "left", value: "is_deposit" },
                { text: "Ghi Chú", align: "left", value: "note" },
            ],
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Mã quản lý', value: 'roomStateId' },
            ],
            list_room_status: [
                { text: 'Trống, báo trả', value: 0 },
                { text: 'Đã cọc, chưa vào ở', value: 1 },
                { text: 'Tất cả', value: '' },
            ],
            chosen_room_status: 0,
            chosen_building: '',
            items: [],
            loading: {
                submit: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            search_type: 'roomId',
            menu_date_start: false,
            menu_date_end: false,
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substring(0, 10),
            room_status,
            days_count_alert_for_checkin: 1,
            print_portal: false,
            export_csv: {
                loading: false,
                trigger: false,
                title: "",
                rows: []
            },
        };
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        user_role(){
            return this.$store.state.auth.role;
        }
    },
    mounted() {
    },
    async created(){
        // if (this.user_role == "admin"){
        //     console.log(this.user_role);
        //     this.headers.splice(4, 0,
        //         { text: "Hình", align: "center", value: "has_picture" }
        //     );
        // }
        this.getData()
    },
    methods: {
        getData: async function (){
            this.items = []
            this.loader = true
            const params = {
                building: this.chosen_building,
                roomStatus: this.chosen_room_status,
                // [this.search_type]: this.search,
            }
            const query = buildParamQuery(params)
            let data = await api.getTwoNewestRoomStateEachRoom(query)
            this.items = data.data
                .map((room_data, index) => {
                        const current_rs = room_data.current_room_state;
                        const old_rs = room_data.old_room_state;
                        if (!current_rs) return room_data
                        room_data.room_state_id = current_rs.room_state_id;
                        room_data.phone = current_rs.phone;
                        room_data.date_in = current_rs.date_in
                        room_data.is_deposit = !current_rs.deposit_status ? current_rs.deposits && current_rs.deposits.length ? 'Chưa cọc đủ' : 'Chưa cọc' : 'Đủ'
                        room_data.room_status = this.handleRoomStatus(current_rs)
                        room_data.date_schedule_in = current_rs.date_schedule_in
                        room_data.is_check_in_alert = current_rs.date_in ? false : this.checkAlertForCheckIn(current_rs.date_schedule_in)
                        // Lố ngày: Nếu có ngày thực nhận, ngày thực nhận lớn hơn ngày hẹn
                        // hoặc Nếu ko có ngày thực nhận thì ngày hiện tại lớn hơn ngày hẹn
                        room_data.is_passed_date_schedule_in = moment(current_rs.date_in).diff(moment(current_rs.date_schedule_in), 'days') > 0
                        room_data.date_schedule_out = current_rs.date_schedule_out ? current_rs.date_schedule_out : old_rs ? old_rs.date_schedule_out : '';
                        room_data.date_out = current_rs.date_out || current_rs.date_schedule_out ? current_rs.date_out : old_rs ? old_rs.date_out : '';
                        if (current_rs.devicesInfo && current_rs.devicesInfo.length){
                            const ac = current_rs.devicesInfo.find(dv => dv.type == "AC")
                            if (ac.is_valid){
                                room_data.is_current_ac = true;
                                // room_data.room_price += room_data.air_conditioner_price || 0;
                            }
                        }
                        // if (room_state.old_room_state){
                        //     room_status
                        // }
                        // room_state.current_room_state = this.handleData(room_state.current_room_state);
                        // room_state.old_room_state = this.handleData(room_state.old_room_state);
                        // room_data.index = index
                        const found_room = this.rooms.find(room => room.room_id == room_data.room_id)
                        room_data.has_picture = found_room.has_picture;
                        room_data.picture_description = found_room.picture_description;
                        room_data.room_price_standard = found_room ? found_room.room_price_standard : null;
                        room_data.room_code = found_room ? found_room.room_code : null;
                        room_data.status_text = room_status[room_data.room_status] || room_status[0]
                    return room_data
                })
            this.loader = false
        },
        handleRoomStatus: function (state){
            if (state.date_out) return 0
            else if (state.date_schedule_out) return 3
            else if (state.check_in_id) return 2
            else if (state.deposits && state.deposits.length) return 1
            return 0
        },
        checkAlertForCheckIn: function (date_schedule_in){
            const now = new Date();
            const day_diff = dayDiff(date_schedule_in, now);
            return day_diff < this.days_count_alert_for_checkin
        },
        updateRoomPicture: async function (room){
            const {  _id, picture_description_new  } = room;
            const data = await api.updateReceipt(`/rooms/${_id}`,
                {
                    has_picture: !!picture_description_new,
                    picture_description: picture_description_new
                }
            );

            if (data.status == 200){
                room.picture_description = picture_description_new;
                room.has_picture = !!picture_description_new;
                swal.fire('Thành công', 'Cập nhật mã hình thành công', 'success')
            } else {
                swal.fire('Thất bại', data.message, 'error')
            }
		},
        saveNote: async function (room){
            const old_note = room.note
            const room_state_id = room.room_state_id
            const data = await api.updateRoomState({room_state_id, note: room.new_note})
            if (data.status == 200){
                room.note = room.new_note
                swal.fire('Thành công', 'Cập nhật ghi chú thành công', 'success')
            } else {
                room.note = old_note
                swal.fire('Thất bại', data.message, 'error')
            }
        },
		exportCSV: function(){

			const rows = this.items.map((item, index) => {
                const is_ac = item.is_included_air_conditioner || item.is_current_ac

                return {
                    'STT': index + 1,
                    'Phòng': item.room_id,
                    'Mã phòng': item.room_code || '',
                    'Hình': item.picture_description || item.has_picture || "",
                    'Tình Trạng':
                        item.room_status
                        ? `${formatTimeServer(item.date_schedule_out)}${ is_ac ? " (ML)" : ""}`
                        : `${room_status[item.room_status || 0]}${ is_ac ? ", máy lạnh" : ""}`,
                    'Giá Phòng Cho Thuê': item.room_price,
                    'Giá Chuẩn': item.room_price_standard ? this.$options.filters.formatNumber(item.room_price_standard) : '',
                    'SĐT': item.phone,
                    'Ngày Báo Trả': formatTimeServer(item.date_schedule_out),
                    'Ngày Thực Trả': formatTimeServer(item.date_out),
                    'Đã Trả Cọc': item.return_deposit_status_text,
                    'Ngày Báo Nhận': formatTimeServer(item.date_schedule_in),
                    'Ngày Thực Nhận': formatTimeServer(item.date_in),
                    'Đã Thu Cọc': item.is_deposit || 'Chưa cọc',
                    'Ghi Chú': item.note
                }
            });

			this.export_csv.rows = rows;
			const date = new Date().toISOString().substring(0, 10)
			this.export_csv.title = "tinh-trang-phong-" + date;
			this.export_csv.trigger = !this.export_csv.trigger;
		}
    }
};
</script>
<style scoped>
.ts-warning {
    /* font-weight: bold !important; */
    color: #ff9200 !important;
}
</style>